import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IonPopover} from '@ionic/angular';
import {NotificationItem, NotificheService} from '../../../_services/notifiche.service';
import {Subscription} from 'rxjs';
import {blurActiveOverlayFocus, PopoverBackdropGuard, getPopoverHostElement} from '../../../_helpers/popover-focus-guard';

@Component({
    selector: 'app-centro-notifiche',
    templateUrl: './centro-notifiche.component.html',
    styleUrls: ['./centro-notifiche.component.scss'],
    standalone: false
})
export class CentroNotificheComponent implements OnInit, OnDestroy {
  @ViewChild('popover') popover?: IonPopover;
  @ViewChild('triggerButton', {read: ElementRef}) triggerButton?: ElementRef<HTMLElement>;
  isOpen = false;
  subscription: Subscription;
  private readonly backdropGuard = new PopoverBackdropGuard(
    () => getPopoverHostElement(this.popover),
    () => this.releaseFocus()
  );
  notificheDaLeggere: Array<NotificationItem> = [];
  notificheVisibili: Array<NotificationItem> = [];
  notificheAlert: Array<NotificationItem> = [];
  tempoAttualeSecondi = 0;

  constructor(private notificheService: NotificheService) { }

  ngOnInit() {
    this.subscription = this.notificheService.notifiche.subscribe((_notifiche) => {
      this.notificheDaLeggere = _notifiche.filter((notifica) => !notifica.read);
      if (!this.isOpen) {
        this.notificheVisibili = [...this.notificheDaLeggere];
      }
    });
    this.subscription.add(this.notificheService.notificheAlert.subscribe((_alert) => this.notificheAlert = _alert));
    setInterval(() => this.tempoAttualeSecondi = new Date().valueOf() / 1000, 10);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.backdropGuard.detach();
  }

  onDidPresent = () => {
    this.backdropGuard.attach();
  };

  onWillClose = () => {
    this.backdropGuard.blurBackdrop();
    this.releaseFocus();
  };

  onClose = () => {
    this.isOpen = false;
    this.notificheVisibili = [...this.notificheDaLeggere];
    this.backdropGuard.blurBackdrop();
    this.releaseFocus();
  };

  presentPopover(event: Event) {
    this.releaseFocus(event);

    if (this.popover) {
      this.popover.event = this.buildPopoverEvent(event);
    }
    this.notificheVisibili = [...this.notificheDaLeggere];
    this.isOpen = true;
    this.notificheService.markAllAsRead();
  }

  private buildPopoverEvent(event: Event): Event {
    const triggerElement = this.triggerButton?.nativeElement;

    if (!triggerElement) {
      return event;
    }

    const mouseEvent = event as MouseEvent;

    return {
      target: triggerElement,
      currentTarget: triggerElement,
      clientX: mouseEvent.clientX,
      clientY: mouseEvent.clientY
    } as unknown as Event;
  }

  private releaseFocus(event?: Event): void {
    blurActiveOverlayFocus(event, this.triggerButton?.nativeElement);
  }
}
